import { render, staticRenderFns } from "./UserGroupEditor.vue?vue&type=template&id=3d6a548d&scoped=true"
import script from "./UserGroupEditor.vue?vue&type=script&lang=js"
export * from "./UserGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a548d",
  null
  
)

export default component.exports